import { render, staticRenderFns } from "./DistributorCard.vue?vue&type=template&id=bc9d4b62&scoped=true"
import script from "./DistributorCard.vue?vue&type=script&lang=js"
export * from "./DistributorCard.vue?vue&type=script&lang=js"
import style0 from "./DistributorCard.vue?vue&type=style&index=0&id=bc9d4b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9d4b62",
  null
  
)

export default component.exports